import { render, staticRenderFns } from "./RecipientsStep.vue?vue&type=template&id=f264d95c&scoped=true&"
import script from "./RecipientsStep.vue?vue&type=script&setup=true&lang=js&"
export * from "./RecipientsStep.vue?vue&type=script&setup=true&lang=js&"
import style0 from "./RecipientsStep.vue?vue&type=style&index=0&id=f264d95c&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f264d95c",
  null
  
)

export default component.exports